import { LocationAutoSuggest } from 'app/employer/components/autoSuggest';
import withAutoSuggestFormik from './withAutoSuggestFormik';
import withInputErrorMessage from '../withInputErrorMessage';
import withMultiSelectAutosuggest from './withMultiSelectAutosuggest';
import autosuggestFactory from './autosuggestFactory';
import { getGeoLocationSASuggestions } from '../../../app/services/geoDataService';
import apiDataResponseHandler from '../../../util/promiseFactory/apiDataResponseHandler';

const locationMultiSelectAutoSuggest = autosuggestFactory({
   apiPromise: getGeoLocationSASuggestions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndNameAsLabelLocationList,
   defaultPlaceholder: 'Search Location...',
});

export default withAutoSuggestFormik(withInputErrorMessage(LocationAutoSuggest));
export const LocationMultiSelectSA = withMultiSelectAutosuggest(locationMultiSelectAutoSuggest);
